export default {
  namespaced: true,
  state: {
    email: null,
    name: null,
    avatar: null,
    uid: null
  },
  mutations: {
    registerUser(state, { user }) {
      state.email = user.email
      state.name = user.name
      state.avatar = user.avatar
      state.uid = user.uid
    }
  }
}
